const bar_de_tragos = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_33145)">
      <path d="M21 5V3H3V5L11 14V19H6V21H18V19H13V14L21 5ZM7.43 7L5.66 5H18.35L16.57 7H7.43Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_1_33145">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
export default bar_de_tragos;
